module.exports = __webpack_public_path__ + "static/img/up-arrow.79829608.webp";